<template>
  <div class="layout">
    <NavBar
      :mode="navbarMode"
      :active-menu="activeMenu"
      @navigate="handleNavigate"
    />
    <div class="layout__content">
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
import NavBar from "./navbar/index.vue";
import Footer from "./footer/index.vue";

export default {
  name: "Layout",
  components: { NavBar, Footer },
  computed: {
    navbarMode() {
      return this.$route.meta.navbarMode || "transparent";
    },
    activeMenu() {
      return this.$route.meta.menuKey || "";
    },
  },
  methods: {
    handleNavigate(name) {
      if (this.$route.name !== name) {
        this.$router.push({ name });
      }
    },
  },
};
</script>

<style scoped>
.layout {
  min-height: 100vh;
}

.layout__content {
  /* min-height: calc(100vh - var(--nav-height)); */
  max-width: 1720px;
  margin: 0 auto;
}
</style>
